export const T = {
  en_GB: {
    admin: "Admin",
    title: "Timeseries Instruments",
    description: "QA view of every instrument in the timeseries database and its data status.",
  },
  nb_NO: {
    admin: "Admin",
    title: "Tidsserieinstrumenter",
    description: "QA-visning av alle instrumenter i tidsseriedatabasen og deres datastatus.",
  },
} as const;
